import {
  type ParsedLocation,
  useLocation,
  useRouter,
} from "@tanstack/react-router";
import { resolveCurrentUrlSlug } from "@/shared/lib/currentUrlSlug";

/** Routerの現在locationから、その画面の対象板slugを返す。 */
export function useCurrentUrlSlug(): string | null {
  const router = useRouter();
  const routePathname = useLocation({
    select: (location: ParsedLocation) => location.pathname,
  });
  const publicPathname =
    router.basepath === "/"
      ? routePathname
      : `${router.basepath}${routePathname}`;
  return resolveCurrentUrlSlug(publicPathname);
}
